export const FIELD_MIN_WIDTH = 220;
export const FIELD_MAX_WIDTH = 520;
export const FIELD_LABEL_COLUMNS = 'min(12rem, 40%) minmax(0, 1fr)';
export const FIELD_LABEL_LAYOUT = {
  gridTemplateColumns: FIELD_LABEL_COLUMNS,
  columnGap: '8px',
};
const PANEL_COL_GAP = 14;

export const fieldSizeStyle = {
  width: '100%',
  minWidth: `min(100%, ${FIELD_MIN_WIDTH}px)`,
  maxWidth: FIELD_MAX_WIDTH,
  boxSizing: 'border-box' as const,
};

export const getPanelColumns = (options: unknown): 1 | 2 | 3 => {
  if (!options || typeof options !== 'object' || Array.isArray(options)) {
    return 1;
  }
  const columns = Number((options as { columns?: unknown }).columns);
  if (columns === 2 || columns === 3) return columns;
  return 1;
};

export const getPanelMaxWidth = (columns: 1 | 2 | 3) =>
  columns <= 1
    ? FIELD_MAX_WIDTH
    : columns * FIELD_MAX_WIDTH + (columns - 1) * PANEL_COL_GAP;

/**
 * Default true: designer OtherInfo panels stay collapsible.
 * Order layout groups pass `chrome: false`. Work Order tab also sets
 * `sectionTitle: true` so Basic/Pricing labels remain without panel chrome.
 */
export const panelChromeEnabled = (options: unknown): boolean => {
  if (!options || typeof options !== 'object' || Array.isArray(options)) {
    return true;
  }
  return (options as { chrome?: unknown }).chrome !== false;
};

export const panelSectionTitleEnabled = (options: unknown): boolean => {
  if (!options || typeof options !== 'object' || Array.isArray(options)) {
    return false;
  }
  return (options as { sectionTitle?: unknown }).sectionTitle === true;
};

export const panelSectionSplitEnabled = (options: unknown): boolean => {
  if (!options || typeof options !== 'object' || Array.isArray(options)) {
    return false;
  }
  return (options as { sectionSplit?: unknown }).sectionSplit === true;
};

export const panelHeaderTitleEnabled = (options: unknown): boolean => {
  if (!options || typeof options !== 'object' || Array.isArray(options)) {
    return false;
  }
  return (options as { headerTitle?: unknown }).headerTitle === true;
};
